import styled from "styled-components";
import { mobile } from "src/components";

export const SearchInput = styled.input`
    position: relative;
    background-image: url('data:image/svg+xml;utf8,\
        <svg fill="none" height="18" viewBox="0 0 16 16" width="18" xmlns="http://www.w3.org/2000/svg">\
            <circle cx="6" cy="6" r="5" stroke="%238291B2" stroke-width="1.5"/>\
            <line x1="10" y1="10" x2="13.5" y2="13.5" stroke="%238291B2" stroke-width="1.5" stroke-linecap="round"/>
        </svg>');
    background-repeat: no-repeat;
    font-family: 'Manrope', sans-serif;
    font-size: 14px;
    font-style: normal;
    text-indent: 40px;
    background-position: 16px center;
    box-shadow: none;
    border: 1px solid #D8DEEC;
    border-radius: 8px;
    height: 42px;
    box-sizing: border-box;
    text-align: left;
    width: 400px;
    max-width: 100%;

    ::placeholder {
        font-size: 14px;
        text-align: left;
        color: #8A95AB;
    }

    ${mobile`
        max-width: 190px;
        width: 100%;
    `}

    @media (min-width: 481px) and (max-width: 767px){
        max-width: 420px;
    }

    @media (min-width: 768px) and (max-width: 1024px){
        max-width: 420px;
    }

    @media (min-width: 1025px) and (max-width: 1440px){
     max-width: 300px;
    }

    @media (min-width: 1441px){
        max-width: 500px;
    }
`;

export const Td = styled.td`
    text-align: ${p => p.align || "left"};
    padding-left: ${p => p.paddingLeft || "1rem !important"};
    vertical-align: top;
    border: none !important;
    border-collapse: collapse;
    width: ${p => p.width || "auto"};
`;

export const TdCenter = styled.td`
    text-align: center;
    vertical-align: middle;
    border: none !important;
    & > div {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
    }
`;

export const TdContent = styled.div`
    width: 100%;
    min-height: 60px;
    min-width: 200px;
    max-width: 800px;
    word-break: break-word;
    white-space: normal;
    overflow-wrap: break-word;
    font-family: 'Manrope', sans-serif;
    border: none !important;

    ${mobile`
        min-width: 150px;
        max-width: 300px;
    `}
`;

export const ButtonLabel = styled.button`
    width: 101px;
    height: 32px;
    background: #F3F5FB 0% 0% no-repeat padding-box;
    box-shadow: none;
    border: 1px solid #C9D2E7;
    border-radius: 8px;
    opacity: 1;
    cursor: pointer;
    color: #171A22;
    font-family: 'Manrope', sans-serif;
    font-weight: 500;
    font-size: 12px;
    line-height: 19px;
`;

export const Card = styled.div`
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0 18px 36px rgba(29, 42, 89, 0.08);
    border: 1px solid #D8DEEC;
    border-radius: 8px;
    opacity: 1;
    color: #171A22;
    width: ${p => p.width || "229px"};
    height: ${p => p.height || "76px"}
    display: row;
    padding: ${p => p.padding || "13px"};
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
`;

export const Label = styled.div`
    font-weight: 500;
    font-size: 14px;
`;

export const Number = styled.div`
    font-size: ${p => p.fontSize || "2rem"};
    font-weight: 700;
    font-family: Manrope;
    margin: 0;
    text-align: left;
`;
